const ServicioArchivos ={

  obtenerBytesBase64StringArchivo(archivo,objeto,propiedad){
      //var stringBase64=null;   
      var reader = new FileReader();
      reader.readAsBinaryString(archivo);
      reader.onload=function(){
          var arrayBuffer = this.result;
          var base64Data = btoa(arrayBuffer);
          objeto[propiedad]=base64Data;
         
      };        
  }
}

export default ServicioArchivos;